import type { StructureNavigationItemImplementation } from '../../Shell/PandoraSolutionBuilderAgent/model/enumerations';
import { ChildrenLoader, TreeNode } from '../../Shell/PandoraSolutionBuilderAgent/components/mx-extra-panel/mx-filters-tree/tree-node';

export interface StructureDTO {
	Name: string;
	NodeId: string;
	Icon?: string;
	Parent?: string;
	Children?: StructureDTO[];
}

export interface StructureConfig {
	structureId: string;
	implementationType: StructureNavigationItemImplementation;
	widgetId: string;
	relativePath: string;
}

export interface StructureItem {
	config: StructureConfig;
	nodeId: string;
	name: string;
	icon?: string;
	children?: StructureItem[];
}

export type StructureChildrenLoader = ChildrenLoader<StructureNode>;

export class StructureNode extends TreeNode<StructureItem> {
	public readonly config: StructureConfig;
	public readonly nodeId: string;
	public readonly name: string;
	public readonly icon?: string;

	get id() {
		return this.item.nodeId;
	}

	get title() {
		return this.item.name;
	}

	get nodePath(): string {
		return this.parent?.parent ? `${this.nodeId}_${this.parent.nodePath}` : this.item.nodeId;
	}

	constructor(readonly item: StructureItem) {
		super(item);
		this.config = item.config;
		this.nodeId = item.nodeId;
		this.name = item.name;
		this.icon = item.icon;
	}
}
